import { Solid } from 'remotion';
import React from 'react';

export const Ai: React.FC = () => {
	return (
		<>
			<Solid
				width={1920}
				height={1080}
				color={'#0b6ba5'}
				style={{ position: 'absolute' }}
			/>
		</>
	);
};
